import { useNavigate } from "@solidjs/router";
import InviteService from "../../services/InviteService";
import type { InviteSummary } from "../../state/invite";
import { useTranslation } from "../../state/i18n";
import { useAuthDispatch, useAuthState } from "../../state/auth";
import moreappBrandIcon from "../../assets/moreapp-icon-brand.svg";
import { TextButton } from "../../components/button/Button";
import Section from "../Section";
import Layout from "../Layout";

type InviteAcceptanceExistingUserStateProps = {
  invite: InviteSummary;
  token: string;
};

const InviteAcceptanceExistingUserState = (props: InviteAcceptanceExistingUserStateProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuthState();
  const { login } = useAuthDispatch();
  const acceptInviteMutation = InviteService.acceptInvite();

  // The token subject is the username, which is the email address the invite was sent to
  const isLoggedInAsInvitedUser = () =>
    user.latest?.profile.sub.toLowerCase() === props.invite.emailAddress.toLowerCase();

  const openCustomer = () => {
    const customerPath = `/customers/${props.invite.customerId}`;
    if (isLoggedInAsInvitedUser()) {
      navigate(customerPath);
      return;
    }
    // Accepting does not log in, and whoever is logged in now (locally or at the identity server) may be another account
    void login(customerPath, { forcePrompt: true });
  };

  const acceptInvitation = () => {
    acceptInviteMutation.mutate({ token: props.token }, { onSuccess: openCustomer });
  };

  return (
    <Layout>
      <Section centerOnMobile>
        <div class="w-full mobile:p-6">
          <img
            src={moreappBrandIcon}
            alt={t(($) => $.MOREAPP_LOGO_IMG_ALT)}
            class="mx-auto mb-10 size-12 mobile:mx-0"
          />
          <h1 class="mb-6 flex flex-col gap-y-1 text-medium-regular text-secondary">
            {t(($) => $.INVITE_PAGE_TITLE)}
            <span class="text-header-3xl text-primary">{props.invite.customerName}</span>
          </h1>
          <TextButton
            text={t(($) => $.INVITE_PAGE_ACCEPT_BUTTON_LABEL)}
            onClick={acceptInvitation}
            loading={acceptInviteMutation.isPending}
            disabled={acceptInviteMutation.isPending}
            block
          />
        </div>
      </Section>
    </Layout>
  );
};

export default InviteAcceptanceExistingUserState;
